import { lazy } from 'react';

const DeclarationStepRoute = lazy(
  () => import('../components/steps/declaration-step/DeclarationStep'),
);

export default DeclarationStepRoute;
